module.exports = __webpack_public_path__ + "img/image13.906480a0.jpg";